import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

import { ReportCategory, ReportPriority } from '../../../../../models/reports';
import { IssueReportService } from '../../../../../services/reports.service';

@Component({
  selector: 'app-reports-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIcon,
  ],
  templateUrl: './issue-reports-dialog.html',
  styleUrl: './issue-reports-dialog.css',
})
export class IssueReportsDialog {
  reportService = inject(IssueReportService);
  dialogRef = inject(MatDialogRef);
  form = new FormGroup({
    title: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    description: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    category: new FormControl<ReportCategory | null>(null, Validators.required),
    priority: new FormControl<ReportPriority | null>(null, Validators.required),
    attachment: new FormControl<File | null>(null),
  });

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files?.length) {
      return;
    }

    this.form.controls.attachment.setValue(input.files[0]);
  }

  submitReport(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const raw = this.form.getRawValue();

    const formData = new FormData();
    formData.append('title', raw.title);
    formData.append('description', raw.description);
    formData.append('category', raw.category!);
    formData.append('priority', raw.priority!);

    if (raw.attachment) {
      formData.append('attachment', raw.attachment);
    }

    this.reportService.createReport(formData).subscribe({
      next: (createdReport) => {
        this.dialogRef.close(createdReport);
      },
      error: (err) => {
        console.error('createReport failed:', err);
      },
    });
  }
}
